<template lang="pug">
  v-container.ma-0
    base-snackbar(
      :errors.sync="recievedInventoryUpdatePutErrors"
    )
    v-row
      v-col(
        lg="4"
        cols="12"
      )
        v-text-field(
          label="Receipt No"
          :value="receiptNo"
          disabled
        )
      v-col(
        lg="4"
        cols="12"
      )
        v-text-field(
          label="Supplier ID"
          disabled
          :value="supplierId"
        )
      v-col(
        lg="4"
        cols="12"
      )
        v-text-field(
          disabled
          label="Stock Code"
          :value="stockCode"
        )
      v-col(cols="12")
        v-text-field(
          label="Transaction Date"
          type="date"
          :error-messages="recievedInventoryUpdatePutErrors.date_recieved"
          v-model="dateTransaction"
        )
      v-col(cols="12")
        v-text-field(
          label="Cost Per Unit"
          prefix="₱"
          type="number"
          :error-messages="recievedInventoryUpdatePutErrors.cost"
          v-model="cost"
        )
      v-col(cols="6")
        v-text-field(
          label="Quantity"
          type="number"
          v-model="quantity"
          :error-messages="recievedInventoryUpdatePutErrors.quantity"
        )
      v-col(cols="6")
        v-autocomplete(
          label="Unit"
          :items="units"
          v-model="unit"
          :error-messages="recievedInventoryUpdatePutErrors.unit"
        )
      v-col(cols="12")
        v-textarea(
          label="Notes"
          v-model="notes"
          no-resize
          auto-grow
          rows="1"
          :error-messages="recievedInventoryUpdatePutErrors.notes"
        )
      v-col(cols="12")
        v-btn(
          color="green"
          @click="updateRecievedInventory"
          :loading="recievedInventoryUpdatePutting"
        )
          span Save Transaction
</template>
<script>
import recievedInventoryRepository from '@/repositories/recieved-inventory.repository'
import VueRequestHandler from '@/classes/VueRequestHandler.class'
import requestVars from '@/extra-functions/request-vars.extra'
import { moneyMixin } from './../../mixins/helper.mixins'
import { mapState } from 'vuex'
import { SuccessPopup } from '../../../../lib/utils'

const [recievedInventoryUpdateVars, recievedInventoryUpdateVarNames] = requestVars({ identifier: 'recieved-inventory-update', hasData: false, request: 'put' })

const recievedInventoryUpdateHandler = new VueRequestHandler(null, recievedInventoryUpdateVarNames)

const inputVars = () => {
  return {
    receiptNo: null,
    supplierId: null,
    searchInput: null,
    cost: null,
    stockCode: '',
    unit: '',
    unitSearchInput: null,
    quantity: null,
    dateTransaction: null,
    notes: null,
    id: null,
  }
}

export default {
  name: 'EditRecievedInventories',
  data() {
    return {
      ...inputVars(),
      ...recievedInventoryUpdateVars,
      filter: {},
      tempUnits: [],
    }
  },
  computed: {
    ...mapState({
      updateErrors: state => state.recievedInventory.updateErrors,
      updateSuccess: state => state.recievedInventory.updateSuccess,
      updating: state => state.recievedInventory.updating,
      units: state => state.unit.allList.map(unit => unit.unit),
    }),
  },
  watch: {
    updateSuccess(val) {
      if (val) {
        this.resetInputs()
        this.closeDialog()
      }
    },
  },
  methods: {
    // ...mapActions({
    //   update: 'recievedInventory/update',
    // }),
    filterComboBox(item, queryText, itemText) {
      const regX = new RegExp(queryText, 'i')
      return regX.test(`${item.unit}${item.description}`)
    },
    closeDialog() {
      this.$emit('close-dialog')
    },
    populateInputs(data) {
      this.receiptNo = data.receipt_no
      this.supplierId = data.supplier_id
      this.stockCode = data.stock_code
      this.cost = data.cost
      this.unit = data.unit
      this.quantity = data.quantity
      this.dateTransaction = data.date_purchased
      this.id = data.id
    },
    resetInputs() {
      this.supplierId = null
      this.stockCode = null
      this.cost = null
      this.unit = null
      this.quantity = null
      this.dateTransaction = null
    },
    dateFormat(ndate) {
      const date = new Date(ndate)
      const year = date.getFullYear()
      const month = (`${date.getMonth() + 1}`).padStart(2, '0')
      const day = (`${date.getDate()}`).padStart(2, '0')

      return `${month}/${day}/${year}`
    },
    updateRecievedInventory() {
      const handler = recievedInventoryUpdateHandler
      const repository = recievedInventoryRepository.update
      const data = {
        cost: this.cost,
        unit: this.unit,
        quantity: this.quantity,
        date_recieved: this.dateTransaction,
        notes: this.notes,
      }
      handler.setVue(this)
      handler.execute(repository, [this.id, data], () => {
        this.resetInputs()
        this.closeDialog()
        SuccessPopup.fire({ text: 'Purchase Item updated successfully!' })
        this.$emit('update')
      })
    },
  },
  mixins: [
    moneyMixin,
  ],
}
</script>
<style lang="scss" scoped>
.truncate {
  max-width: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
